import { SampleButton } from "../../../../content/blog/2035-01-01_testing-grounds/code-example/sample-code";
import * as React from 'react';
export default {
  SampleButton,
  React
};